const gri2021_indicators = {
  namespaced: true,
  state: {
    topic_payloads: [],
    indicator_payloads: [],
  },
  mutations: {
    upload_topic_payload(state, new_obj) {
      // payload object 통으로 갈아끼우거나 넣음
      // 오직 저장만을 위한 용도로, 화면 뿌리는 것은 여기서 관리하지 않음
      let new_arr = [...state.topic_payloads];
      let temp_id = Object.keys(new_obj)[0];
      let idz = new_arr.findIndex((z) => {
        return Object.keys(z)[0] == temp_id;
      });
      if (idz > -1) {
        new_arr.splice(idz, 1, new_obj);
      } else new_arr.push(new_obj);
      state.topic_payloads = new_arr;
    },
    upload_indicator_payload(state, new_obj) {
      // payload object 통으로 갈아끼우거나 넣음
      // 오직 저장만을 위한 용도로, 화면 뿌리는 것은 여기서 관리하지 않음
      let new_arr = [...state.indicator_payloads];
      let temp_id = Object.keys(new_obj)[0];
      let idz = new_arr.findIndex((z) => {
        return Object.keys(z)[0] == temp_id;
      });
      if (idz > -1) {
        new_arr.splice(idz, 1, new_obj);
      } else new_arr.push(new_obj);
      state.indicator_payloads = new_arr;
    },
    empty_topic_payloads(state) {
      state.topic_payloads = [];
    },
    empty_indicator_payloads(state) {
      state.indicator_payloads = [];
    },
  },
  getters: {},
  actions: {},
};

export default gri2021_indicators;
